import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaiairporttopunecab() {



const cardData = {
  keyword: " Navi Mumbai Airport to Pune Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Navi Mumbai Airport to Pune cab services for travelers looking for a smooth and convenient intercity journey between Navi Mumbai International Airport and the vibrant city of Pune. Whether you are traveling for business meetings, family visits, vacations, or corporate travel, our cab service ensures a safe and stress-free ride with experienced drivers and well-maintained vehicles. The road distance between Navi Mumbai Airport and Pune is approximately 120–140 km depending on the route, usually taking around 2.5 to 3.5 hours via the Mumbai–Pune Expressway. We offer flexible booking options including one-way transfers, round-trip packages, and multi-day travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual airport pickups, professional chauffeurs familiar with expressway driving, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai Airport to Pune cab booking.",

topPlaces: [
  {
    title: "Shaniwar Wada",
    description:
      "Shaniwar Wada is one of the most famous historical landmarks in Pune and was once the seat of the Peshwa rulers of the Maratha Empire. Built in the 18th century, the fort features massive gates, stone walls, and remnants of royal palace structures. Visitors come to explore the historic ruins, learn about Maratha history, and enjoy the evening light and sound show that narrates the story of the fort. Travelers arriving from Navi Mumbai Airport can conveniently visit Shaniwar Wada by cab and explore this iconic heritage site comfortably."
  },
  {
    title: "Aga Khan Palace",
    description:
      "Aga Khan Palace is a historic building in Pune known for its role in India’s freedom movement. The palace once served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters during the British era. Today it houses a museum with photographs, personal items, and exhibits related to India’s independence struggle. The beautiful gardens and grand architecture make it an important cultural landmark. A cab journey from Navi Mumbai Airport to Pune allows visitors to easily include this historic site in their itinerary."
  },
  {
    title: "Sinhagad Fort",
    description:
      "Sinhagad Fort is a historic hill fort located on the outskirts of Pune and is famous for its connection to the Maratha warrior Tanaji Malusare. The fort sits atop a hill and offers breathtaking panoramic views of the surrounding valleys and mountains. Visitors often trek to the fort, enjoy local Maharashtrian food, and explore ancient structures and temples within the fort complex. Booking a cab from Navi Mumbai Airport provides a comfortable way to reach the base area of this scenic fort."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description:
      "Dagdusheth Halwai Ganpati Temple is one of the most famous temples in Pune dedicated to Lord Ganesha. The temple is known for its beautifully decorated idol and grand celebrations during Ganesh Chaturthi. Devotees and tourists visit throughout the year to seek blessings and experience the spiritual atmosphere. Traveling by cab from Navi Mumbai Airport to Pune ensures a comfortable and convenient journey to this important religious destination."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description:
      "Raja Dinkar Kelkar Museum houses an impressive collection of Indian artifacts including musical instruments, sculptures, paintings, and everyday objects from different historical periods. The museum offers visitors a fascinating glimpse into India’s cultural heritage and traditional craftsmanship. Travelers interested in history and art often include this museum in their Pune sightseeing plans. A cab ride from Navi Mumbai Airport allows easy access to this cultural attraction."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description:
      "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is one of the most beautiful landscaped gardens in Pune. Inspired by Japanese garden design, the park features flowing water streams, wooden bridges, walking paths, and lush greenery. Visitors come here to relax, enjoy nature, and take photographs in a peaceful environment. Travelers arriving from Navi Mumbai Airport can conveniently reach this scenic garden by cab."
  },
  {
    title: "Pataleshwar Cave Temple",
    description:
      "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva located in the heart of Pune city. Carved from a single rock in the 8th century, the temple features impressive stone pillars and a peaceful prayer hall. Visitors often explore the temple to admire its unique architecture and spiritual ambiance. A cab service from Navi Mumbai Airport to Pune makes it easy to visit this historic temple."
  },
  {
    title: "Parvati Hill Temple",
    description:
      "Parvati Hill is a well-known viewpoint and religious site in Pune featuring temples dedicated to Lord Shiva, Goddess Parvati, and other deities. Visitors climb a series of steps to reach the top where they are rewarded with panoramic views of Pune city. The location is popular for sunrise and sunset visits as well as for its peaceful atmosphere. Hiring a cab from Navi Mumbai Airport provides convenient travel for visitors planning to explore this scenic hilltop temple."
  },
  {
    title: "Pune Camp Area",
    description:
      "The Camp area of Pune is a vibrant neighborhood known for its colonial-era buildings, shopping streets, cafes, and restaurants. Visitors can explore markets like MG Road and East Street where they can shop for clothing, souvenirs, and local snacks. The lively atmosphere makes it a popular destination for both tourists and locals. A cab ride from Navi Mumbai Airport allows travelers to comfortably explore this bustling part of the city."
  },
  {
    title: "Katraj Snake Park",
    description:
      "Katraj Snake Park is a unique wildlife attraction in Pune that houses various species of snakes, reptiles, and turtles. The park is part of the Rajiv Gandhi Zoological Park and serves as an educational center for wildlife conservation and awareness. Families, students, and wildlife enthusiasts visit to learn about reptiles and observe them in safe enclosures. Booking a cab from Navi Mumbai Airport to Pune makes it convenient for travelers to include this interesting attraction in their visit."
  }
],



services: [
{
name: "Navi Mumbai Airport to Pune Cab",
description: "Navi Mumbai Airport to Pune cab service provides reliable and comfortable transportation for travelers arriving at Navi Mumbai International Airport and heading to Pune. This route is widely used by business travelers, tourists, and families traveling between Mumbai and Pune. Our fleet includes AC sedans, SUVs, and premium vehicles suitable for highway journeys. Professional drivers ensure safe driving along the Mumbai–Pune Expressway and guarantee punctual airport pickup services. Pickup is available directly from airport terminals with luggage assistance. Spacious seating and smooth ride quality make the journey relaxing. Ideal for corporate transfers, family travel, and airport pickups."
},
{
name: "Navi Mumbai Airport to Pune Taxi",
description: "Navi Mumbai Airport to Pune taxi service offers dependable intercity transportation between the airport and Pune city. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance travel. Professional drivers ensure punctual pickup from the airport arrival terminal and safe driving during the journey. Air-conditioned vehicles ensure relaxed travel even during long traffic hours. Ideal for corporate travelers, tourists, and families traveling from Navi Mumbai airport to Pune. Flexible booking options allow convenient travel planning."
},
{
name: "Cab from Navi Mumbai Airport to Pune",
description: "Cab from Navi Mumbai Airport to Pune provides convenient transportation for travelers who need direct airport pickup and transfer to Pune city. Vehicles provide comfortable seating and smooth ride quality suitable for highway travel. Professional drivers ensure punctual pickup from the airport terminal and safe travel across the expressway. Spacious vehicles allow comfortable luggage storage for travelers arriving with baggage."
},
{
name: "Taxi from Navi Mumbai Airport to Pune",
description: "Taxi from Navi Mumbai Airport to Pune offers comfortable intercity transportation for passengers traveling from the airport to Pune. Vehicles provide air-conditioned interiors, comfortable seating, and smooth ride quality suitable for long-distance travel. Professional drivers ensure punctual pickup services and safe highway driving."
},
{
name: "Navi Mumbai Airport Pune Cab Service",
description: "Navi Mumbai Airport Pune cab service provides reliable airport transportation for passengers traveling between Navi Mumbai airport and Pune city. Vehicles are clean, comfortable, and suitable for highway journeys. Professional drivers ensure timely pickups and smooth travel along the expressway. Pickup is available from airport terminals with assistance for luggage."
},
{
name: "Navi Mumbai Airport Pune Taxi Service",
description: "Navi Mumbai Airport Pune taxi service provides dependable intercity travel for passengers needing direct airport transfers to Pune. Vehicles provide comfortable seating and reliable ride performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe travel throughout the route."
},
{
name: "Navi Mumbai Airport to Pune Cab Booking",
description: "Navi Mumbai Airport to Pune cab booking allows travelers to easily reserve vehicles for airport transfers with quick confirmation. Online and phone booking options provide flexible scheduling for airport arrivals. Vehicles provide comfortable seating and reliable performance suitable for long-distance travel."
},
{
name: "Navi Mumbai Airport to Pune Taxi Booking Online",
description: "Navi Mumbai Airport to Pune taxi booking online provides quick digital reservations for passengers planning airport transfers. Travelers can schedule pickups online and receive instant booking confirmation. Vehicles provide comfortable seating and smooth ride quality suitable for the journey."
},
{
name: "Navi Mumbai Airport to Pune Cab Price",
description: "Navi Mumbai Airport to Pune cab price options provide transparent fare estimates based on vehicle category and travel distance. Passengers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size. Clear pricing ensures easy travel planning."
},
{
name: "Navi Mumbai Airport to Pune Taxi Fare",
description: "Navi Mumbai Airport to Pune taxi fare services offer flexible pricing depending on vehicle type and trip duration. Passengers can choose economical sedans or spacious SUVs depending on their travel preferences."
},
{
name: "Navi Mumbai Airport to Pune One Way Cab",
description: "Navi Mumbai Airport to Pune one way cab service provides economical intercity transportation without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for expressway travel."
},
{
name: "Navi Mumbai Airport to Pune Round Trip Taxi",
description: "Navi Mumbai Airport to Pune round trip taxi service offers convenient travel options for passengers planning return journeys. Vehicles remain available for both directions ensuring comfortable travel for airport transfers and return trips."
},
{
name: "Navi Mumbai Airport to Pune Innova Cab",
description: "Navi Mumbai Airport to Pune Innova cab service provides spacious MPV transportation ideal for families and small groups traveling with luggage. Toyota Innova vehicles offer comfortable seating and smooth highway performance suitable for airport transfers."
},
{
name: "Navi Mumbai Airport to Pune Ertiga Cab",
description: "Navi Mumbai Airport to Pune Ertiga cab service provides comfortable MPV travel suitable for families and group travelers. The Maruti Ertiga offers spacious seating and smooth ride quality ideal for expressway journeys."
},
{
name: "Navi Mumbai Airport to Pune Sedan Cab",
description: "Navi Mumbai Airport to Pune sedan cab service provides economical and comfortable transportation for individual travelers and small families. Sedan vehicles offer smooth ride quality and air-conditioned interiors suitable for airport transfers."
}
],

tableData: [
["Navi Mumbai Airport to Pune Cab","Navi Mumbai Airport to Pune Taxi"],
["Cab from Navi Mumbai Airport to Pune","Taxi from Navi Mumbai Airport to Pune"],
["Navi Mumbai Airport Pune Cab Service","Navi Mumbai Airport Pune Taxi Service"],
["Navi Mumbai Airport to Pune Cab Booking","Navi Mumbai Airport to Pune Taxi Booking Online"],
["Navi Mumbai Airport to Pune Cab Price","Navi Mumbai Airport to Pune Taxi Fare"],
["Navi Mumbai Airport to Pune One Way Cab","Navi Mumbai Airport to Pune Round Trip Taxi"],
["Navi Mumbai Airport to Pune Innova Cab","Navi Mumbai Airport to Pune Ertiga Cab"],
["Navi Mumbai Airport to Pune Sedan Cab","Airport to Pune Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance travel from Navi Mumbai Airport to Pune. They are familiar with the Mumbai–Pune Expressway and alternate routes, ensuring a safe and smooth journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai Airport to Pune cab bookings. Customers receive clear details about per-kilometer fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport to Pune cab service operates 24 hours a day. Whether your flight lands early morning or late at night, we provide reliable airport pickup services anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to ensure passengers enjoy a comfortable intercity travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way airport drop, round-trip travel, and same-day return packages between Navi Mumbai Airport and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers for families and groups."
  },
  {
    WhyChooseheading: "Direct Airport Pickup Service",
    WhyChoosedescription: "Our drivers provide convenient pickup directly from the Navi Mumbai Airport terminal and assist passengers with luggage for a smooth start to the journey."
  },
  {
    WhyChooseheading: "Reliable Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai Airport to Pune trips. Our punctual drivers, comfortable vehicles, and professional service ensure stress-free travel."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Navi Mumbai Airport to Pune?", answer: "Yes, Omshree Cabs provides reliable cab services from Navi Mumbai Airport to Pune for both one-way and round-trip travel." },
  { question: "What is the distance from Navi Mumbai Airport to Pune?", answer: "The distance from Navi Mumbai Airport to Pune is approximately 150 km and the journey usually takes around 3 to 4 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Navi Mumbai Airport to Pune?", answer: "Yes, we offer both one-way and round-trip cab services between Navi Mumbai Airport and Pune." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight arrival schedules." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do drivers track flight arrival times?", answer: "Yes, our drivers monitor flight schedules to ensure timely pickup even if flights are delayed." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback:
      "We booked Omshree Cabs from Navi Mumbai Airport to Pune. The driver was punctual and the journey via expressway was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "Excellent airport transfer service. Clean car, polite driver, and hassle-free travel from Navi Mumbai Airport to Pune.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Navi Mumbai Airport to Pune Cab Service",
  "description": "Omshree Cab provides reliable cab service from Navi Mumbai Airport to Pune. Choose one-way or round trips with Innova, Ertiga, or sedan cabs. Book online 24/7 at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Omshree Cab",
    "telephone": "+91 9892544084",
    "url": "https://www.omshreecab.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": "Outstation Cab Service"
};








  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai Airport to Pune Cab | Omshree Cab | One-way & Round Trip</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai Airport to Pune cab service with Omshree Cab. Get one-way or round-trip pickups in Innova, Ertiga, or sedan cabs. Safe, affordable, and available 24/7." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairporttopunecab;